import { RelayEnvironmentProvider } from '@atlassian/relay-environment-provider';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import { envType } from './common/types';
import '@atlaskit/css-reset/dist/bundle.css';
import { AppWithAuthContext } from './ui/AppWithAuthContext';
import { getEnvType } from './utils';
import { devAnalyticsClient } from './utils/analytics/client';
import { initReactUFO } from './utils/analytics/ufo/initUFO';

Sentry.init({
	environment: getEnvType(),
	enabled: getEnvType() !== envType.LOCAL,
	dsn: 'https://aa7f49d6af9f98e93324071287d92bb8@o55978.ingest.us.sentry.io/4508946351521793',
	tracesSampleRate: 1.0, // Capture 100% of the transactions
});

initReactUFO(devAnalyticsClient);

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<RelayEnvironmentProvider>
		<AppWithAuthContext />
	</RelayEnvironmentProvider>,
);
